document.addEventListener('DOMContentLoaded', function() {
    var productsWithCountdown = document.querySelectorAll('[id^="countdown-"]');
    productsWithCountdown.forEach(function(element) {
        var productId = element.id.replace('countdown-', '');
        var releaseDate = new Date(Shopify.products[productId].metafields.namespace.key);
        var x = setInterval(function() {
            var now = new Date().getTime();
            var distance = releaseDate - now;
            if (distance < 0) {
                clearInterval(x);
                element.innerHTML = "NOW AVAILABLE!";
                return;
            }
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            element.innerHTML = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
        }, 1000);
    });
});
